var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Button as MUIButton, useTheme } from '@mui/material';
import React from 'react';
import { buttonStyles as classes } from './buttonStyles';
function getVariantStyles(variant, paletteColor) {
    const variantStyles = {
        text: classes['variant-text'](paletteColor),
        outlined: classes['variant-outlined'](paletteColor),
        contained: classes['variant-contained'](paletteColor),
    };
    return variant ? variantStyles[variant] : variantStyles.contained;
}
function getSizeStyles(size) {
    const sizeStyles = {
        large: classes['size-large'],
        medium: classes['size-medium'],
        small: classes['size-small'],
        tiny: classes['size-tiny'],
    };
    return size ? sizeStyles[size] : sizeStyles.medium;
}
function ButtonComponent(_a, ref) {
    var { customColor, size = 'medium', children, href, variant, color } = _a, muiButtonProps = __rest(_a, ["customColor", "size", "children", "href", "variant", "color"]);
    const theme = useTheme() || {};
    const paletteColor = customColor ||
        (Object.keys(theme).length
            ? theme.palette[color === 'primary' || color === 'secondary' ? color : 'primary'].main
            : 'initial');
    return (_jsx(MUIButton, Object.assign({ ref: ref, href: href, variant: variant, color: color, css: [classes.button, getSizeStyles(size), getVariantStyles(variant, paletteColor)] }, muiButtonProps, { children: children })));
}
/**
 * @deprecated Use the V2Button component instead.
 */
export const Button = React.forwardRef(ButtonComponent);
